export const eLabelsFiltersName = {
  countryFilter: 'countryFilter',
  updateUserUsernameFilter: 'updateUserUsernameFilter',
  creationDateFilter: 'creationDateFilter',
  lastUpdateFilter: 'lastUpdateFilter',
  nationalGITypeFilter: 'nationalGITypeFilter',
  geoIndicationFilter: 'geoIndicationFilter',
  wineTypeFilter: 'wineTypeFilter',
  wineTypeEUFilter: 'wineTypeEUFilter',
  wineColourFilter: 'wineColourFilter',
  additionalInfoFilter: 'additionalInfoFilter',
  sweetnessTypeFilter: 'sweetnessTypeFilter',
  vintageFilter: 'vintageFilter',
  bottleSizeFilter: 'bottleSizeFilter',
  packageTypeFilter: 'packageTypeFilter',
  brandFilter: 'brandFilter',
  grapesFilter: 'grapesFilter',
  specialClassificationFilter: 'specialClassificationFilter',
  ingredientsFilledFilter: 'ingredientsFilledFilter',
  nutritionDeclarationFilledFilter: 'nutritionDeclarationFilledFilter',
  alcoholLevelFilter: 'alcoholLevelFilter',
}

export const eLabelsFiltersTitle = {
  countryFilter: 'filters.names.country',
  updateUserUsernameFilter: 'filters.names.users',
  creationDateFilter: 'filters.names.creationDate',
  lastUpdateFilter: 'filters.names.lastUpdate',
  nationalGITypeFilter: 'filters.names.nationalGITypeFilter',
  geoIndicationFilter: 'filters.names.geoIndicationFilter',
  wineTypeFilter: 'filters.names.wineTypeFilter',
  wineTypeEUFilter: 'filters.names.wineTypeEUFilter',
  wineColourFilter: 'filters.names.wineColourFilter',
  additionalInfoFilter: 'filters.names.certificatesFilter',
  sweetnessTypeFilter: 'filters.names.sweetnessTypeFilter',
  vintageFilter: 'filters.names.vintageFilter',
  bottleSizeFilter: 'filters.names.bottleSizeFilter',
  packageTypeFilter: 'filters.names.packageTypeFilter',
  alcoholLevelFilter: 'filters.names.alcoholLevelFilter',
  brandFilter: 'filters.names.brandFilter',
  ingredientsFilledFilter: 'filters.names.ingredientsFilledFilter',
  nutritionDeclarationFilledFilter:
    'filters.names.nutritionDeclarationFilledFilter',
  specialClassificationFilter: 'filters.names.specialClassificationFilter',
}

export const eLabelsFiltersKey = () => {
  return {
    countryFilter: 'wine.country',
    updateUserUsernameFilter: 'updateUserUsername',
    creationDateFilter: 'createdAt',
    lastUpdateFilter: 'updatedAt',
    nationalGITypeFilter: 'wine.nationalGIType',
    geoIndicationFilter: 'wine.geoIndication',
    wineTypeFilter: 'wine.wineType',
    wineTypeEUFilter: 'wine.wineTypeEU',
    wineColourFilter: 'wine.wineColor',
    additionalInfoFilter: 'wine.certification',
    sweetnessTypeFilter: 'wine.sweetnessLevel',
    vintageFilter: 'wine.vintage',
    bottleSizeFilter: 'bottleSize',
    packageTypeFilter: 'packageType',
    brandFilter: 'wine.brand',
    specialClassificationFilter: 'wine.specialClassification',
    ingredientsFilledFilter: 'ingredientsFilled',
    nutritionDeclarationFilledFilter: 'nutritionDeclarationFilled',
    alcoholLevelFilter: 'alcoholOnLabel',
  }
}
